export const appVersion = '0.2.17';
export const baseStripeUrl = 'https://buy.stripe.com/';

export const devStripeUrls = {
  homeAnalysis: `${ baseStripeUrl }test_3csfZc9mvfhN0Ks14a`,
  enterpriseAnalysis: `${ baseStripeUrl }test_3cs3cq1U3glR0Ks8wD`,
  businessSubscription: `${ baseStripeUrl }test_fZefZceGPglRctaeV3`,
  businessPlusSubscription: `${ baseStripeUrl }test_7sI7sG7en4D91Ow7sA`,
};


// When changing maps API key here, change in index.non-prod.html
export const devMapsApiKey = 'AIzaSyBMxAaodb3Ia4CYHteG2av6btxq2kw8-6M'; // dev key
// export const devMapsApiKey = 'AIzaSyAjGqFwmZjIlZBtJhpzmxduUuhwtAewuTU'; // prod key
